import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CollapseChangeService{
  private isCollapsedSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public isCollapsed$ = this.isCollapsedSubject.asObservable();

  setIsCollapsed(value: boolean) {
    this.isCollapsedSubject.next(value);
  }
}